import { cleanUrl } from '@wix/wix-chatbot-common/browser';

import { renderModel } from '../../util/renderModel';

export interface SuggestedQuestion {
  id: string;
  name: string;
}

const getTranslationKeys = (url: string): string[] => {
  if (renderModel.isEditor3()) {
    return [0, 1, 2].map((i) => `widget-search-suggestion-editor3-${i}`);
  }
  if (url.includes('editor.wix.com/html/editor')) {
    return [0, 1, 2].map((i) => `widget-search-suggestion-${i}-classic-editor`);
  }
  try {
    const path = cleanUrl(url, false).replace(/\//g, '.');
    if (path) {
      return [0, 1, 2].map((i) => `widget-search-suggestion-${i}-${path}`);
    }
  } catch { }
  return [0, 1, 2].map((i) => `widget-search-suggestion-${i}`);
};

export const getSuggestedQuestionsList = (loadPageUrl: string): SuggestedQuestion[] | undefined => {
  if (renderModel.isFullWidth() || renderModel.isCopilot()) {
    return undefined;
  }

  const messages = renderModel.get().messages || {};
  const keys = getTranslationKeys(loadPageUrl);

  return keys.map((key, index) => ({
    id: `suggested-question-${index}`,
    name: messages[key] || messages[`widget-search-suggestion-${index}`] || key,
  }));
};

export const formatSuggestedQuestionsForBi = (
  questions: SuggestedQuestion[] | undefined,
): string | undefined => {
  if (!questions?.length) {
    return undefined;
  }
  return JSON.stringify(questions);
};
